import { useEffect } from "react";
import api from "../../lib/api";

const rid = () => Math.random().toString(36).slice(2, 12) + Date.now().toString(36);
const getId = (store, key) => {
  try {
    let v = store.getItem(key);
    if (!v) { v = rid(); store.setItem(key, v); }
    return v;
  } catch { return rid(); }
};

// Anonymous page-view tracking: random IDs only, no personal data.
export function useVisitTracker(pathname) {
  useEffect(() => {
    const t = setTimeout(() => {
      api.post("/public/visit", {
        path: pathname,
        referrer: document.referrer || "",
        visitor_id: getId(localStorage, "vcaj_vid"),
        session_id: getId(sessionStorage, "vcaj_sid"),
        tz: Intl.DateTimeFormat().resolvedOptions().timeZone || "",
        screen_w: window.innerWidth,
      }).catch(() => {});
    }, 400);
    return () => clearTimeout(t);
  }, [pathname]);
}
